import React from 'react';
import { Whatsapp } from '@saleshandy/icons';

const WhatsappIcon = () => (
  <Whatsapp className='green-txt-13' />
);

export default WhatsappIcon;
